import styled, { css } from 'styled-components';
import { ChevronLeft } from '../../../common/components/icons/ChevronLeft';
import { ThemeColours } from '../../../common/styles/ThemeColours';
import { TagProps } from '../../../common/util/TagLike';

interface Props extends TagProps<'svg'> {
  $right?: boolean;
  $disabled?: boolean;
}

export const CalendarChevron = ({ $right, $disabled, ref, onClick, ...rest }: Props) => (
  <Chevron
    {...rest}
    $right={$right}
    $disabled={$disabled}
    onClick={$disabled ? undefined : onClick}
  />
);

const Chevron = styled.svg.attrs({ as: ChevronLeft })<Props>`
  border: solid 1px ${ThemeColours.black};
  border-radius: 100%;
  color: ${ThemeColours.black};
  cursor: ${props => (props.$disabled ? 'not-allowed' : 'pointer')};
  fill: currentColor;
  height: 20px;
  opacity: ${props => (props.$disabled ? 0.2 : 0.75)};
  transform: ${props => (props.$right ? 'scaleX(-1)' : '')};
  user-select: none;
  width: 20px;

  ${props =>
    !props.$disabled &&
    css`
      &:hover {
        background-color: ${ThemeColours.black};
        color: ${ThemeColours.white};
      }
      &:active {
        transform: scale(0.92);
      }
    `};

  @include transition(background-color 0.2s, color 0.2s, opacity 0.2s, transform 0.2s);
`;
